import React from 'react'
import { PurchaseOrderPage } from './purchase-order-page'

export const PayablePage = () => {
  return <PurchaseOrderPage pageType={3} />;
};
